import React from 'react';
import { useTranslation } from '@corti/i18n';
import { Typography } from 'lib/cortiUI';
export const FieldTitle = ({ title, isRequired }) => {
    const { t } = useTranslation('libFeedbackFormManager');
    return (React.createElement(Typography, { variant: "subtitle2", color: title ? 'default' : 'error' },
        title || t('preview.noTitle', 'No title'),
        React.createElement(Typography, { color: "error", display: "inline" }, isRequired ? ' *' : '')));
};
